export default {
  xy: {
    type: 'array',
    items: { type: 'number' },
  },
}
